import React from "react"
import { SpecialZoomLevel, Plugin, createStore, PluginFunctions } from "@react-pdf-viewer/core"

interface CustomZoomPlugin extends Plugin {
    zoomTo(scale: number | SpecialZoomLevel): void
}
interface StoreProps {
    zoom?(scale: number | SpecialZoomLevel): void
}

const customZoomPlugin = (): CustomZoomPlugin => {
    const store = React.useMemo(() => createStore<StoreProps>({}), [])

    return {
        install: (pluginFunctions: PluginFunctions) => {
            store.update("zoom", pluginFunctions.zoom)
        },
        zoomTo: (scale: number | SpecialZoomLevel) => {
            const zoom = store.get("zoom")
            if (zoom) {
                // Zoom to that scale
                zoom(scale)
            }
        },
    }
}

export default customZoomPlugin
